<div class="aca-admin aca-search">
  <aca-page-header icon="search" [title]="'DMS.DOCUMENT_SEARCH.925A0E' | translate" [subtitle]="'DMS.UI.690ECE' | translate">
    <button type="button" class="aca-search__outline" (click)="saveCurrent()" [disabled]="!hasCriteria">
      <mat-icon>bookmark_border</mat-icon>{{ 'DMS.DOCUMENT_SEARCH.902B80' | translate }}
    </button>
  </aca-page-header>

  <!-- ── main search bar ────────────────────────────────────────────────── -->
  <form class="aca-search__bar" (submit)="$event.preventDefault(); run()">
    <mat-icon class="aca-search__baricon">search</mat-icon>
    <input
      type="text"
      class="aca-search__barinput"
      [placeholder]="'DMS.DOCUMENT_SEARCH.98F76A' | translate"
      [(ngModel)]="criteria.term"
      name="term"
      autocomplete="off"
      [attr.aria-label]="'DMS.DOCUMENT_SEARCH.208913' | translate"
    />
    <button type="submit" class="aca-search__primary"><mat-icon>search</mat-icon>{{ 'DMS.DOCUMENT_SEARCH.DF897F' | translate }}</button>
  </form>

  <!-- ── saved searches ─────────────────────────────────────────────────── -->
  <section class="aca-search__saved" *ngIf="savedSearches().length">
    <h2 class="aca-search__savedtitle">{{ 'DMS.DOCUMENT_SEARCH.ABE014' | translate }}</h2>
    <div class="aca-search__savedchips">
      <span class="aca-search__savedchip" *ngFor="let entry of savedSearches(); trackBy: trackByName">
        <button type="button" class="aca-search__savedapply" (click)="applySaved(entry)" [matTooltip]="'DMS.DOCUMENT_SEARCH.757924' | translate">
          <mat-icon>bookmark</mat-icon>
          {{ entry.name }}
        </button>
        <button
          type="button"
          class="aca-search__savedx"
          (click)="removeSaved(entry, $event)"
          [attr.aria-label]="('DMS.UI.245E3D' | translate) + entry.name"
        >
          <mat-icon>close</mat-icon>
        </button>
      </span>
    </div>
  </section>

  <!-- ── advanced filters ───────────────────────────────────────────────── -->
  <section class="aca-search__filters" *ngIf="filtersOpen()">
    <h2 class="aca-search__filterstitle">{{ 'DMS.DOCUMENT_SEARCH.606048' | translate }}</h2>

    <div class="aca-search__grid">
      <div class="aca-search__field">
        <label for="s-type">{{ 'DMS.DOCUMENT_SEARCH.EA3757' | translate }}</label>
        <select id="s-type" class="aca-search__input aca-search__select" [(ngModel)]="criteria.documentType" name="documentType">
          <option value="">{{ 'DMS.DOCUMENT_SEARCH.14CFB0' | translate }}</option>
          <option *ngFor="let option of documentTypes" [value]="option.value">{{ option.label | translate }}</option>
        </select>
      </div>

      <div class="aca-search__field">
        <label for="s-owner">{{ 'DMS.DOCUMENT_SEARCH.B4F2EC' | translate }}</label>
        <input
          id="s-owner"
          type="text"
          class="aca-search__input"
          [placeholder]="'DMS.DOCUMENT_SEARCH.7F4210' | translate"
          [(ngModel)]="criteria.owner"
          name="owner"
        />
      </div>

      <div class="aca-search__field">
        <label for="s-dept">{{ 'DMS.DOCUMENT_SEARCH.7A1CB7' | translate }}</label>
        <input
          id="s-dept"
          type="text"
          class="aca-search__input"
          [placeholder]="'DMS.DOCUMENT_SEARCH.7358AE' | translate"
          [(ngModel)]="criteria.department"
          name="department"
        />
      </div>

      <div class="aca-search__field">
        <label for="s-tag">{{ 'DMS.DOCUMENT_SEARCH.F07115' | translate }}</label>
        <input
          id="s-tag"
          type="text"
          class="aca-search__input"
          [placeholder]="'DMS.DOCUMENT_SEARCH.5E270C' | translate"
          [(ngModel)]="criteria.tag"
          name="tag"
        />
      </div>

      <div class="aca-search__field aca-search__field--range" role="group" [attr.aria-label]="'DMS.DOCUMENT_SEARCH.78F0E6' | translate">
        <span class="aca-search__fieldlabel">{{ 'DMS.DOCUMENT_SEARCH.78F0E6' | translate }}</span>
        <div class="aca-search__range">
          <aca-date-input
            class="aca-search__input"
            [(ngModel)]="criteria.createdFrom"
            name="createdFrom"
            [ariaLabel]="'DMS.DOCUMENT_SEARCH.1FD6D1' | translate"
          />
          <span class="aca-search__rangeto">{{ 'DMS.DOCUMENT_SEARCH.D0EA98' | translate }}</span>
          <aca-date-input
            class="aca-search__input"
            [(ngModel)]="criteria.createdTo"
            name="createdTo"
            [ariaLabel]="'DMS.DOCUMENT_SEARCH.B3174D' | translate"
          />
        </div>
      </div>

      <div class="aca-search__field aca-search__field--range" role="group" [attr.aria-label]="'DMS.DOCUMENT_SEARCH.508B08' | translate">
        <span class="aca-search__fieldlabel">{{ 'DMS.DOCUMENT_SEARCH.508B08' | translate }}</span>
        <div class="aca-search__range">
          <aca-date-input
            class="aca-search__input"
            [(ngModel)]="criteria.modifiedFrom"
            name="modifiedFrom"
            [ariaLabel]="'DMS.DOCUMENT_SEARCH.1FD6D1' | translate"
          />
          <span class="aca-search__rangeto">{{ 'DMS.DOCUMENT_SEARCH.D0EA98' | translate }}</span>
          <aca-date-input
            class="aca-search__input"
            [(ngModel)]="criteria.modifiedTo"
            name="modifiedTo"
            [ariaLabel]="'DMS.DOCUMENT_SEARCH.B3174D' | translate"
          />
        </div>
      </div>

      <div class="aca-search__field">
        <label for="s-status">{{ 'DMS.DOCUMENT_SEARCH.46FAB5' | translate }}</label>
        <select id="s-status" class="aca-search__input aca-search__select" [(ngModel)]="criteria.status" name="status">
          <option value="">{{ 'DMS.DOCUMENT_SEARCH.47A74F' | translate }}</option>
          <option *ngFor="let option of statuses" [value]="option.value">{{ option.label | translate }}</option>
        </select>
      </div>

      <div class="aca-search__field">
        <label for="s-content">{{ 'DMS.DOCUMENT_SEARCH.DD40EA' | translate }}</label>
        <input
          id="s-content"
          type="text"
          class="aca-search__input"
          [placeholder]="'DMS.DOCUMENT_SEARCH.676109' | translate"
          [(ngModel)]="criteria.contentText"
          name="contentText"
        />
      </div>

      <div class="aca-search__field">
        <label for="s-size">{{ 'DMS.DOCUMENT_SEARCH.E06CAF' | translate }}</label>
        <select id="s-size" class="aca-search__input aca-search__select" [ngModel]="sizeIndex" (ngModelChange)="changeSize($event)" name="size">
          <option *ngFor="let band of sizes; let i = index" [value]="i">{{ band.label | translate }}</option>
        </select>
      </div>
    </div>

    <div class="aca-search__filtersfoot">
      <button type="button" class="aca-search__link" (click)="toggleFilters()">
        {{ 'DMS.DOCUMENT_SEARCH.81ACB7' | translate }}<mat-icon>expand_less</mat-icon>
      </button>

      <div class="aca-search__filtersactions">
        <button type="button" class="aca-search__link" (click)="clear()">{{ 'DMS.DOCUMENT_SEARCH.AC9940' | translate }}</button>
        <button type="button" class="aca-search__primary" (click)="run()">
          <mat-icon>search</mat-icon>{{ 'DMS.DOCUMENT_SEARCH.DF897F' | translate }}
        </button>
      </div>
    </div>
  </section>

  <button type="button" class="aca-search__link aca-search__showfilters" *ngIf="!filtersOpen()" (click)="toggleFilters()">
    {{ 'DMS.DOCUMENT_SEARCH.AFD50F' | translate }}<mat-icon>expand_more</mat-icon>
  </button>

  <mat-progress-bar mode="indeterminate" *ngIf="loading()" />

  <!-- ── results ────────────────────────────────────────────────────────── -->
  <section class="aca-search__results" *ngIf="searched() && !failed()">
    <div class="aca-search__resultshead">
      <h2 class="aca-search__resultstitle">
        {{ 'DMS.DOCUMENT_SEARCH.DC82CE' | translate
        }}<span class="aca-search__resultscount" *ngIf="!loading()">
          {{
            rowTotal() !== null
              ? (rowTotal() | number) + ('DMS.UI.591519' | translate)
              : ('DMS.UI.0020EB' | translate) + (rangeEnd | number) + ('DMS.UI.591519' | translate)
          }}
        </span>
      </h2>

      <div class="aca-search__resultsactions">
        <label class="aca-search__filter">
          <span class="aca-search__filterlabel">{{ 'DMS.DOCUMENT_SEARCH.58DB33' | translate }}</span>
          <select class="aca-search__select aca-search__selectbare" [ngModel]="sort" (ngModelChange)="changeSort($event)" name="sort">
            <option *ngFor="let option of sorts" [value]="option.value">{{ option.label | translate }}</option>
          </select>
        </label>

        <div class="aca-search__viewtoggle">
          <button
            type="button"
            class="aca-search__iconbtn"
            [class.aca-search__iconbtn--on]="view() === 'list'"
            (click)="setView('list')"
            [matTooltip]="'DMS.DOCUMENT_SEARCH.3519B3' | translate"
            [attr.aria-label]="'DMS.DOCUMENT_SEARCH.3519B3' | translate"
          >
            <mat-icon>view_list</mat-icon>
          </button>
          <button
            type="button"
            class="aca-search__iconbtn"
            [class.aca-search__iconbtn--on]="view() === 'grid'"
            (click)="setView('grid')"
            [matTooltip]="'DMS.DOCUMENT_SEARCH.81D7AA' | translate"
            [attr.aria-label]="'DMS.DOCUMENT_SEARCH.81D7AA' | translate"
          >
            <mat-icon>grid_view</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <aca-page-state
      *ngIf="!loading() && !rows().length"
      state="not-found"
      [title]="'DMS.DOCUMENT_SEARCH.3D7803' | translate"
      [message]="'DMS.UI.5D12A0' | translate"
      [actionLabel]="'DMS.UI.6A3C95' | translate"
      (action)="clear()"
    />

    <!-- list view -->
    <div class="aca-search__list" *ngIf="rows().length && view() === 'list'">
      <article class="aca-search__hit" *ngFor="let hit of rows(); trackBy: trackById">
        <span class="aca-search__badge aca-search__badge--lg" [ngClass]="badgeClass(hit)">
          <mat-icon *ngIf="hit.isFolder">folder</mat-icon>
          <ng-container *ngIf="!hit.isFolder">{{ badge(hit) }}</ng-container>
        </span>

        <div class="aca-search__hitbody">
          <button type="button" class="aca-search__hitname" (click)="open(hit)">{{ hit.name }}</button>
          <p class="aca-search__hitpath">{{ hit.location || '—' }}</p>
          <p class="aca-search__hitdesc" *ngIf="hit.description">{{ hit.description }}</p>

          <div class="aca-search__hittags" *ngIf="hit.tags.length || hit.documentType || hit.documentCode">
            <span class="aca-search__chip" *ngIf="hit.documentType">{{ label(hit.documentType) | translate }}</span>
            <span class="aca-search__chip" *ngIf="hit.documentCode">{{ hit.documentCode }}</span>
            <span class="aca-search__chip" *ngFor="let tag of hit.tags">{{ tag }}</span>
          </div>

          <p class="aca-search__hitmeta">
            {{ 'DMS.UI.DC1FAC' | translate }} {{ hit.modifiedAt | acaDate: 'd MMM y HH:mm' }}
            <ng-container *ngIf="hit.modifiedByName">· {{ 'DMS.UI.78ABAC' | translate }} {{ hit.modifiedByName }}</ng-container>
            <ng-container *ngIf="formatSize(hit.sizeInBytes)">· {{ formatSize(hit.sizeInBytes) }}</ng-container>
          </p>

          <!-- what the page itself said, when that is how it was found -->
          <div class="aca-search__scanfound" *ngIf="hit.ocrPage">
            <span class="aca-search__scantag">
              <mat-icon>document_scanner</mat-icon
              >{{
                (hit.ocrPages?.length ?? 0) > 1
                  ? ('DMS.DOCUMENT_SEARCH.OCR_PAGES' | translate: { count: hit.ocrPages?.length, pages: pageList(hit.ocrPages) })
                  : ('DMS.DOCUMENT_SEARCH.OCR_PAGE' | translate: { p0: hit.ocrPage })
              }}
            </span>
            <span class="aca-search__scanfrag" *ngFor="let fragment of hit.ocrFragments"
              ><ng-container *ngFor="let part of fragmentParts(fragment)"
                ><em *ngIf="part.hit">{{ part.text }}</em
                ><ng-container *ngIf="!part.hit">{{ part.text }}</ng-container></ng-container
              ></span
            >
          </div>
        </div>

        <div class="aca-search__hitside">
          <span class="aca-search__owner" *ngIf="hit.modifiedByName">
            <span class="aca-search__avatar">{{ initials(hit.modifiedByName) }}</span>
            {{ hit.modifiedByName }}
          </span>
          <span class="aca-search__hitdate">{{ hit.modifiedAt | acaDate: 'd MMM y' }}</span>
          <button
            mat-icon-button
            [matMenuTriggerFor]="hitMenu"
            [matTooltip]="'DMS.DOCUMENT_SEARCH.6D5E7B' | translate"
            [attr.aria-label]="'DMS.DOCUMENT_SEARCH.6D5E7B' | translate"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #hitMenu="matMenu">
            <button mat-menu-item (click)="open(hit)">
              <mat-icon>open_in_new</mat-icon><span>{{ 'DMS.DOCUMENT_SEARCH.22AADB' | translate }}</span>
            </button>
          </mat-menu>
        </div>
      </article>
    </div>

    <!-- grid view -->
    <div class="aca-search__grid2" *ngIf="rows().length && view() === 'grid'">
      <button type="button" class="aca-search__card" *ngFor="let hit of rows(); trackBy: trackById" (click)="open(hit)">
        <span class="aca-search__badge aca-search__badge--lg" [ngClass]="badgeClass(hit)">
          <mat-icon *ngIf="hit.isFolder">folder</mat-icon>
          <ng-container *ngIf="!hit.isFolder">{{ badge(hit) }}</ng-container>
        </span>
        <span class="aca-search__cardname">{{ hit.name }}</span>
        <span class="aca-search__cardmeta">{{ label(hit.documentType) || (hit.isFolder ? 'DMS.UI.848311' : 'DMS.UI.D997F7') | translate }}</span>
      </button>
    </div>

    <div class="aca-search__pager" *ngIf="rows().length">
      <span class="aca-search__range2">{{ 'DMS.UI.1D31FB' | translate }} {{ rangeStart | number }}–{{ rangeEnd | number }}</span>
      <div class="aca-search__pages">
        <button type="button" class="aca-search__iconbtn" [disabled]="pageIndex === 0" (click)="previousPage()">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <span class="aca-search__pagenum">{{ pageIndex + 1 }}</span>
        <button type="button" class="aca-search__iconbtn" [disabled]="!hasMore()" (click)="nextPage()">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </div>

    <details class="aca-search__query" *ngIf="rows().length || searched()">
      <summary>{{ 'DMS.DOCUMENT_SEARCH.32C7F7' | translate }}</summary>
      <code>{{ queryPreview }}</code>
    </details>
  </section>

  <aca-page-state
    *ngIf="failed()"
    state="error"
    [title]="'DMS.DOCUMENT_SEARCH.554F58' | translate"
    [message]="failed()"
    [actionLabel]="'DMS.UI.324E7E' | translate"
    (action)="run()"
  />
</div>
